import { createLazyWithRetry } from '@sgme/react';
import { ComponentType } from 'react';
import { getFrontLogger } from 'utils/loggers/FrontLogger';

const retryImport = createLazyWithRetry({
  maxRetries: 5,
  logCallback: (msg, ...other) => {
    try {
      getFrontLogger()?.warn(msg, ...other);
    } catch {
      // eslint-disable-next-line no-console
      console.warn('FAILED TO LOG', msg, ...other);
    }
  },
});

export function lazyWithRetry<TResult extends { default: ComponentType<any> }>(importer: () => Promise<TResult>) {
  return retryImport(importer);
}
